import { getMessages } from '../../../../../store/constants';

export const CLASS_UNREAD_COUNTER = 'unread-counter';

export const MAX_COUNT = 100;

export const MAX_COUNT_LABEL = getMessages().getText('unread-counter.max');
